import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class LeaveRule  {
    _originalTypeClassName = "zSHR.BO.LeaveRule";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
LeaveRule.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Abbreviation = null;
this.Statutory = false;
this.LawPolicy = null;
this.Notes = null;
this.Entitlement = null;
this.AbsenceRuleLeave = null;
this.AbsenceAccrualEffect = false;
this.ParticipatesInPayroll = false;
this.IsPayable = false;
this.DocumentationIsRequired = false;
this.DocumentationDescription = null;
this.CanBeRequestedByEmployee = false;
this.SubsidyRight = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Abbreviation:any;
Statutory:any;
LawPolicy:any;
Notes:any;
Entitlement:any;
AbsenceRuleLeave:any;
AbsenceAccrualEffect:any;
ParticipatesInPayroll:any;
IsPayable:any;
DocumentationIsRequired:any;
DocumentationDescription:any;
CanBeRequestedByEmployee:any;
SubsidyRight:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}